import { useContext } from "react";
import { TradingGlobalContext } from "../context/TradingGlobalContext";
export var ThemeName = /*#__PURE__*/function (ThemeName) {
  ThemeName["light"] = "normal";
  ThemeName["dark"] = "dark";
  return ThemeName;
}({});
export var TICKER_COLOR_GREEN = "#27A59A";
export var TICKER_COLOR_RED = "#EF534F";

/**
 * 给context的default value，实际上是无效数据。初始化组件时就应该被外部真是值所覆盖
 */
export var DEFAULT_THEME = {
  name: ThemeName.dark,
  reversed: true,
  colorIncrease: TICKER_COLOR_RED,
  colorDecrease: TICKER_COLOR_GREEN,
  // colorDone: "#999",
  colorPrimary: "#1F3267",
  colorAccent: "#5793F1",
  colorAccent2: "#FF6F2C",
  windowBackground: "#F7F7F9",
  windowBackground2: "#F7F7F9",
  colorBackground: "#FFFFFF",
  colorBackground2: "#FFFFFF",
  colorBackground3: "#FFFFFF",
  colorText: "#858CA3",
  colorText2: "#576282",
  colorText5: "#999999",
  colorText6: "#052337",
  colorTextAccent: "#333333",
  colorTextHint: "#A9AEBE",
  colorDivider: "#ECECEC",
  colorDivider2: "#ECECEC",
  dialogTitleBackground: "#FFFFFF",
  colorDialogTextChecked: "#1F3267",
  colorLoading: "#00000077",
  colorNav: "#F2F2F2",
  colorWarning: "#E97042",
  colorFavor: "#FFA744",
  colorBorder: "#D9D9D999",
  colorBorder2: "#CCCCCC",
  separator: "#F2F2F2",
  colorEdit: "#1A274C",
  colorBlue: "#4d6ba6",
  increaseTextHeavy: "#1db773",
  indexCardTextColor: "#666666",
  hoverTablesHoverBg: "#f9f9f9",
  BotContentBg: "#FCFCFC",
  warning: "#DB4D4D",
  popover: "#FFFFFF",
  inputBorder: "#E4E7ED",
  c_C9CCD1_454B57: "#C9CCD1"
  // c_292C33_FFFFFF: "#292C33",
};

export function useTheme() {
  var _useContext = useContext(TradingGlobalContext),
    themeData = _useContext.themeData;
  return themeData;
}